import { KeyboardArrowDown, MoreHoriz, Search } from "@material-ui/icons";
import React from "react";
import { Button, Col, Dropdown, Form, Row, Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { getSubscriptionCounterAction } from "./../../actions/SubscriptionReportAction";
import { connect } from "react-redux";
import noRecord from "./../../assets/img/no-record.png";
import ImageLoader from "react-load-image";
import placeholderImage from "./../../assets/img/property-placeholder.jpg";
import loaderImage from "../../assets/img/Ring-Preloader.gif";
import UrlConstants from "./../../config/UrlConstants";
import * as code from "./../../config/Constants";

function Preloader(props) {
  return <img src={loaderImage} />;
}

class CounterReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscription: [],
      originalSubscription: [],
      filteredSubscription: [],
      showLoader: true,
      showCounterDetail: false,
      communication: [],
      searchParam: "",
      recordPerPage: code.RECORD_PER_PAGE,
      page: 0,
    };
  }

  columns = [
    {
      name: "BUYER AGENT NAME",
      selector: "name",
      sortable: true,
      width: "140px",
    },
    {
      name: "Subscription Type",
      selector: "subscription",
      sortable: true,
      width: "150px",
    },
    {
      name: "Custom Templates created",
      selector: "template",
      sortable: true,
      width: "120px",
      right: true,
    },
    {
      name: "Contacts Added",
      selector: "contact",
      sortable: true,
      width: "120px",
      right: true,
    },
    {
      name: "Total Transactions",
      selector: "transaction",
      sortable: true,
      width: "120px",
      right: true,
    },
    {
      name: "Total Text/SMS",
      selector: "text",
      sortable: true,
      width: "120px",
      right: true,
    },
    {
      name: "Total Emails",
      selector: "email",
      sortable: true,
      width: "110px",
      right: true,
    },
    {
      name: "Total Document Size (MB)",
      selector: "document",
      sortable: true,
      width: "120px",
      right: true,
    },
    {
      name: "Current Transactions",
      selector: "currentTransactions",
      sortable: true,
      width: "120px",
      right: true,
    },
  ];

  componentWillMount() {
    // this.getSubscriptionReportList(this.state.page);
  }

  changePage = async (page) => {
    // this.getSubscriptionReportList(page - 1);
  };
  // getSubscriptionReportList(pageIndex) {
  //   this.props.getSubscriptionCounterAction(this.state.recordPerPage,pageIndex).then(res => {
  //     this.setState({
  //       subscription: this.props.subscriptionData || [],
  //       originalSubscription: this.props.subscriptionData || [],
  //       filteredSubscription: this.props.subscriptionData || [],
  //       showLoader: false
  //     })
  //   }).catch(err => { })
  // }
  search(param) {
    param = param.trim();
    var subscription = [];
    subscription = this.state.filteredSubscription.filter((o) => {
      var found = false;
      Object.keys(o).forEach((v) => {
        if (v === "userId") {
          var firstName = o[v].firstname + "";
          var lastName = o[v].lastname + "";
          var fullName = firstName + " " + lastName;
          if (
            firstName.toLowerCase().includes(param.toLowerCase()) ||
            lastName.toLowerCase().includes(param.toLowerCase()) ||
            fullName.toLowerCase().includes(param.toLowerCase())
          ) {
            found = true;
          }
        } else if (v == "productName") {
          var item = o[v] + "";
          if (item.toLowerCase().includes(param.toLowerCase())) {
            found = true;
          }
        }
      });
      return found;
    });
    this.setState({
      subscription,
      searchParam: param,
    });
  }
  render() {
    let rows = [];
    let subscriptionData = this.state.subscription || [];
    for (var i = 0, len = subscriptionData.length; i < len; i++) {
      let user = subscriptionData[i];

      let data = {
        name: !!user.userId
          ? user.userId.firstname + " " + user.userId.lastname
          : "",
        subscription: !!user.productName ? user.productName : "",
        contact: !!user.contactCounter ? user.contactCounter : "0",
        template: !!user.templateCounter ? user.templateCounter : "0",
        transaction: !!user.transactionCounter ? (
          user.transactionCounter !== 0 ? (
            <Button
              variant="link"
              className="p-0"
              onClick={() => {
                this.setState({
                  showCounterDetail: true,
                  communication: user.communicationCounter,
                });
              }}
            >
              {" "}
              {user.transactionCounter}
            </Button>
          ) : (
            "0"
          )
        ) : (
          "0"
        ),
        email: !!user.emailSentCounter ? user.emailSentCounter : "0",
        text: !!user.textSentCounter ? user.textSentCounter : "0",
        document: !!user.uploadDocumentSizeCounter
          ? user.uploadDocumentSizeCounter
          : "0",
        currentTransactions: !!user.transactionLimitCounter
          ? user.transactionLimitCounter
          : "0",
      };
      rows.push(data);
    }
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">System Usage Report</h4>
          </Col>
          <Col xs="4" align="right">
            <div className="icon-wrapper ml-2">
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.search(e.target.value);
                  this.setState({ searchParam: e.target.value });
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
        </Row>

        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area counter-report">
            <DataTable
              columns={this.columns}
              data={rows}
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Records Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              onRowSelected={this.getSelectedRows}
              pagination={true}
              paginationServer={true}
              paginationTotalRows={this.props.totalSubscription}
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />
          </div>
        )}

        <Modal
          className="usage_report_pop"
          show={this.state.showCounterDetail}
          onHide={() => this.setState({ showCounterDetail: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Usage Report</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div class="table_wrap">
              <table
                class="data_tab"
                border="0"
                width="100%"
                cellpadding="0"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>Transaction</th>
                    <th>Text SMS</th>
                    <th>Email</th>
                    <th>Document Size(MB)</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.communication.map((comm) => {
                    return (
                      <tr>
                        <td>
                          <div class="trans-combo">
                            <div class="trans-img">
                              {" "}
                              {comm.transactionData.property.image == null ||
                              comm.transactionData.property.image.length <= 0 ||
                              comm.transactionData.property.image[0] == "" ? (
                                <img src={placeholderImage} />
                              ) : (
                                <ImageLoader
                                  src={
                                    UrlConstants.AdminCreateTransactionUrl +
                                    "/upload?id=" +
                                    comm.transactionData.ownerId +
                                    "&img=" +
                                    comm.transactionData.property.image[0]
                                  }
                                >
                                  <img />
                                  <img src={placeholderImage} />
                                  <Preloader />
                                </ImageLoader>
                              )}
                            </div>
                            <div class="trans-info">
                              <h5>
                                {" "}
                                {comm.transactionData.property.street +
                                  (comm.transactionData.property.street1 != ""
                                    ? ", " +
                                      comm.transactionData.property.street1 +
                                      ""
                                    : "")}{" "}
                              </h5>
                              <p>
                                {" "}
                                {comm.transactionData.property.city +
                                  ", " +
                                  (comm.transactionData.property.state
                                    ? comm.transactionData.property.state + " "
                                    : "") +
                                  comm.transactionData.property.zipcode}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>
                          {!!comm.textSentCounter ? comm.textSentCounter : "0"}
                        </td>
                        <td>
                          {!!comm.emailSentCounter
                            ? comm.emailSentCounter
                            : "0"}
                        </td>
                        <td>
                          {!!comm.uploadDocumentSizeDisplay
                            ? comm.uploadDocumentSizeDisplay
                            : "0"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subscriptionData: state.reducer.subscriptionData,
    totalSubscription: state.reducer.totalSubscription,
  };
};

export default connect(
  mapStateToProps,
  { getSubscriptionCounterAction }
)(CounterReport);
